import { PageBrands } from "@components/modules/brands/listing/PageBrands";
import { NavigationBrands } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Brands`} navigation={<NavigationBrands />}>
    <DemoModule module={Modules.Clients}>
      <PageBrands />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/brands/")({
  component: Page,
});
